import "core-js/modules/es6.string.link.js";
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import { SELF_TARGET } from '~/const/button';
export default {
  name: 'PricingPlan',
  components: {
    SimpleParagraph: SimpleParagraph
  },
  props: {
    header: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerBgColor: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitleRich: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    price: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    subprice: {
      type: String,
      default: ''
    },
    subpriceStrike: {
      type: Boolean,
      default: false
    },
    image: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    cta: {
      type: String,
      default: ''
    },
    ctatheme: {
      type: String,
      default: ''
    },
    link: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    paragraphTitle: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paragraph: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tracking: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    ctaClasses: function ctaClasses() {
      if (this.ctatheme === 'link') return ['btn-link', 'btn-link-u'];
      var btnTheme = this.ctatheme === 'primary' ? 'dark' : 'light';
      return ['btn', "btn-".concat(btnTheme)];
    },
    target: function target() {
      var _this$link$target;
      return (_this$link$target = this.link.target) !== null && _this$link$target !== void 0 ? _this$link$target : SELF_TARGET;
    }
  },
  methods: {
    onClick: function onClick(event) {
      this.$root.$emit('generic-tracking', event, this.tracking);
    }
  }
};